module.exports = __webpack_public_path__ + "img/icono_swpizq.0d114399.svg";